import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  enableMultiTabIndexedDbPersistence,
  initializeFirestore,
} from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import config from "../../config";

const app = initializeApp(config.firebase_config);
const auth = getAuth();
auth.useDeviceLanguage();

const firestore = initializeFirestore(app, { ignoreUndefinedProperties: true });
enableMultiTabIndexedDbPersistence(firestore);

const functions = getFunctions(app, config.region);

export { app, auth, firestore, functions };
